var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", [
    _c(
      "div",
      { staticClass: "form-group" },
      [
        _vm.label
          ? _c("label", { attrs: { for: _vm.name } }, [
              _vm._v(_vm._s(_vm.label)),
            ])
          : _vm._e(),
        _vm.required
          ? _c("span", { staticClass: "text-danger" }, [_vm._v(" *")])
          : _vm._e(),
        _vm._v(" "),
        _c("flat-pickr", {
          staticClass: "form-control",
          attrs: {
            id: _vm.name,
            name: _vm.name,
            placeholder: _vm.placeholder,
            disabled: !!_vm.disabled,
            config: _vm.config,
          },
          on: { "on-change": _vm.onChange },
          model: {
            value: _vm.vModel,
            callback: function ($$v) {
              _vm.vModel = $$v
            },
            expression: "vModel",
          },
        }),
        _vm._v(" "),
        _vm._m(0),
      ],
      1
    ),
    _vm._v(" "),
    _vm.errors && _vm.errors[_vm.error_name || _vm.name]
      ? _c("small", {
          staticClass: "form-text text-danger",
          domProps: {
            textContent: _vm._s(_vm.errors[_vm.error_name || _vm.name][0]),
          },
        })
      : _vm._e(),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("span", { staticClass: "date-icon" }, [
      _c("i", { staticClass: "far fa-calendar-alt" }),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }